module.exports = __webpack_public_path__ + "assets/img/smartTV-module1-2.357de24a.jpg";